import React from 'react';
import { DocumentDuplicateIcon, CheckIcon, XMarkIcon } from '@heroicons/react/24/outline';
import { useCopyToClipboard } from '../hooks/useCopyToClipboard';

interface CopyIconButtonProps {
  text: string;
  label: string;
  className?: string;
  iconClassName?: string;
}

// Icon-only copy button with in-place copied/failed state.
export const CopyIconButton: React.FC<CopyIconButtonProps> = ({
  text,
  label,
  className = 'p-1 text-secondary hover:text-primary transition-colors',
  iconClassName = 'w-4 h-4',
}) => {
  const { copy, status } = useCopyToClipboard();

  return (
    <button
      onClick={() => copy(text)}
      className={className}
      title={status === 'copied' ? 'Copied!' : status === 'error' ? `Failed to copy ${label}` : `Copy ${label}`}
    >
      {status === 'copied' ? (
        <CheckIcon className={`${iconClassName} text-primary`} />
      ) : status === 'error' ? (
        <XMarkIcon className={`${iconClassName} text-red-400`} />
      ) : (
        <DocumentDuplicateIcon className={iconClassName} />
      )}
    </button>
  );
};

export default CopyIconButton;
